import * as React from "react";
import { useHistory, Link } from "react-router-dom";
import EdelLogo from "../../../../assets/icons/svgIcons/logo";

//styles
import DeviceContext from "../../../service/indentifyDevice";

import EdButton, { EdLinkButton } from "../../../generic/edButton";
import { ftHelpDetails } from "../ftConstants";
import indexer from "../../../types/genericTypes";
import "../../../../assets/scss/components/toc/fundTransfer/ftModal/ftModal.scss";
import { Idevice } from "../../../types/device";

const handleDevice: Idevice = DeviceContext();

if (!handleDevice.isMobile) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftModal/ftModalDesk.scss");
} else if (handleDevice.isMobile) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftModal/ftModalMob.scss");
}

export interface IFtFundsModalProps {
	status: React.ReactNode;
	showFooter: boolean;
	showLogo: boolean;
	closeLink?: string;
}
export interface IFtModalFooterProps {}
export function FtModalFooter(props: IFtModalFooterProps) {
	return (
		<div className="ftModalFooter">
			<div className="ftblks note">
				<p className="blkHdg">Note:</p>
				<p className="desc">You will be redirected to payment status, once payment response is received from the service provider.</p>
			</div>
			<div className="ftblks call">
				<p className="blkHdg">Call us</p>
				<a href={"tel:" + ftHelpDetails.tel} className="ftrLink num">
					{ftHelpDetails.tel}
				</a>
				<p className="desc">({ftHelpDetails.timings})</p>
			</div>
			<div className="ftblks email">
				<p className="blkHdg">Email</p>
				<a href={"mail:" + ftHelpDetails.email} className="ftrLink mailid">
					{ftHelpDetails.email}
				</a>
			</div>
		</div>
	);
}

// list of redirections after success full transaction
export function FtSuccessActionsList() {
	return (
		<ul className="ftRedirectLinks taLeft">
			<li>
				<Link to="../place-order">
					<span>Place Order</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link to="../limits">
					<span>Limits</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link to="../add-funds">
					<span>Transfer More Funds</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
		</ul>
	);
}

export const ftStatsIcon: indexer = {
	"200": "edel-icon-tick",
	"0": "edel-icon-exclamation",
	"500": "edel-icon-exclamation",
	"800": "edel-icon-timeout",
	"100": "edel-icon-timeout"
};
export default function FtFundsModal(props: IFtFundsModalProps) {
	const history = useHistory();

	const logoDimensions = {
		desktop: {
			width: "125",
			height: "30",
			viewbox: "0 0 125 30"
		},
		mobile: {
			width: "111",
			height: "20",
			viewbox: "5 5 115 17"
		}
	};

	return (
		<section className="ftModal">
			{/* where conatiner width is set here */}
			<div className="ftModalWrapper">
				<div className="ftModalHeader">
					{props.showLogo && (
						<>
							{handleDevice.isMobile ? (
								<EdelLogo fill="#003e92" {...logoDimensions.mobile} />
							) : (
								<EdelLogo fill="#003e92" {...logoDimensions.desktop} />
							)}
						</>
					)}
					{!props.closeLink ? (
						<EdButton
							className="ftModalClose"
							onClick={() => history.goBack()}
							btnTyp="link"
							value={
								<>
									<i className="edel-icon-close ib vMid"></i>
									<span className="ib vMid">{!handleDevice.isMobile && "Close"}</span>
								</>
							}
						/>
					) : (
						<EdLinkButton
							className="ftModalClose"
							LinkHref={props.closeLink}
							btnTyp="link"
							value={
								<>
									<i className="edel-icon-close ib vMid"></i>
									<span className="ib vMid">{!handleDevice.isMobile && "Close"}</span>
								</>
							}
						/>
					)}
				</div>

				{/* //inner container */}

				<div className="ftInnerWrapper">
					{props.status}
					{props.showFooter && <FtModalFooter />}
				</div>
			</div>
		</section>
	);
}
